import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import RouteErrorBoundary from './components/ErrorBoundary.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <BrowserRouter>
      {/*
        BBB-521 Part 2, merged in from BBB-519.

        BBB-516 wrapped both <Routes> trees inside App, which covers route
        content and nothing else. Nav, the UserContext provider, the
        BgContainer/MainContainer chrome and App's own body all render OUTSIDE
        those two boundaries, so a throw in any of them still unmounts the whole
        tree and produces the blank grey screen BBB-516 existed to kill.

        This is the outer boundary the ticket asks for. It has to sit here rather
        than inside App for two reasons: it must be above App's own body to catch
        it, and it must be below BrowserRouter because RouteErrorBoundary reads
        useLocation and useNavigate.

        Its fallback is safe at this level: ErrorFallback renders plain markup and
        its own CSS module, and touches neither Nav nor UserContext, so the shell
        failing cannot also break the screen that reports the failure.

        Still not covered, and not coverable here: React boundaries only catch
        render, lifecycle and constructor errors. A throw inside a setTimeout or
        a promise callback is not caught by this or any boundary. See the note in
        ErrorBoundary.js.
      */}
      <RouteErrorBoundary>
        <App />
      </RouteErrorBoundary>
    </BrowserRouter>

  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
serviceWorkerRegistration.register();

